import { icons } from '@lifebit-ai/lds'
import React from 'react'

import * as styles from 'modules/resultsV2/PreviousApprovalDetails.styles'
import type { Result } from 'services/results/types'
import { RequestCard } from 'ui/card/card.styles'

import usePreviousApprovalDetails from './hooks/usePreviousApprovalDetails'

interface PreviousApprovalDetailsProps {
  result: Result
}

export const PreviousApprovalDetails = ({ result }: PreviousApprovalDetailsProps): JSX.Element | null => {
  const {
    cardTitle,
    firstOriginalRequestIdentifierUrl,
    originallyApprovedBy,
    originalApprovalDate,
    originalApprovalMethod,
    verificationLabel,
    verificationValue
  } = usePreviousApprovalDetails({ result })

  return (
    <RequestCard>
      <styles.CardContent>
        <styles.CardSectionTitle>{cardTitle}</styles.CardSectionTitle>
        <styles.Details>
          <styles.Label>First original request identifier</styles.Label>
          <styles.Link href={firstOriginalRequestIdentifierUrl} target="_blank" rel="noopener noreferrer">
            <span>Original request</span>
            <icons.OpenSmall />
          </styles.Link>
          <styles.Label>Originally approved by</styles.Label>
          <styles.Value>{originallyApprovedBy}</styles.Value>
          <styles.Label>Original approval date</styles.Label>
          <styles.Value>{originalApprovalDate}</styles.Value>
          <styles.Label>Original approval method</styles.Label>
          <styles.Value>{originalApprovalMethod}</styles.Value>
          <styles.Label>{verificationLabel}</styles.Label>
          <styles.Value>{verificationValue}</styles.Value>
        </styles.Details>
      </styles.CardContent>
    </RequestCard>
  )
}
